<template>
  <div>
    <div class="pt-3 pl-3 fullwidth-p product-wrapper">
      <button class="scroll-btn left" @click="scrollLeft" v-if="showArrows">
        ‹
      </button>
      <div class="product-scroll" ref="scrollBox">
        <div v-for="(item, index) in listProduct" :key="index">
          <div class="d-flex align-items-center text-ellipsis-p cursor" @click="storeMessageProduct(item, index)">
            <img src="@/static/icon/chat/bag.svg" alt="">
            <div class="pl-2 product-name" style="font-size: 12px">
              <span>{{ item.name_des}}</span>
            </div>
          </div>
        </div>
      </div>
      <button class="scroll-btn right" @click="scrollRight" v-if="showArrows">
        ›
      </button>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import EventBus from "@/EventBus";
  export default {
    name: "ProductDetail",
    metaInfo() {
      return {
        title: "",
      };
    },
    props: {
      infoDetail: Object,
    },
    components: {},
    data() {
      return {
        canSubmit: true,
        loading: true,

        listProduct: [],
        showArrows: false,
      };
    },
    computed: {},
    mounted() {
      this.$nextTick(this.checkOverflow)
      window.addEventListener('resize', this.checkOverflow)
    },
    methods: {
      checkOverflow() {
        const el = this.$refs.scrollBox
        if (!el) return
        this.showArrows = el.scrollWidth > el.clientWidth
      },
      storeMessageProduct (item, index) {
        let objData = {
          index: index + 1,
          name_des: item.name_des,
          quantity: item.quantity,
          price: item.price,
          image: item.image,
        };
        EventBus.$emit('messageProduct', objData);

      },
      fetchProduct() {
        this.loading = true;
        axios.get("chat/product/" + this.infoDetail.quote_id).then((response) => {
          this.loading = false;
          switch (response.code) {
            case 200:
              this.listProduct = response.data;
              break;
            default:
              this.$notify.error({
                title: "Error",
                message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
              });
              break;
          }
        });
      },

      scrollLeft() {
        this.$refs.scrollBox.scrollLeft -= 200;
      },
      scrollRight() {
        this.$refs.scrollBox.scrollLeft += 200;
      }

    },
    watch: {
      infoDetail: {
        immediate: true,
        handler(val) {
          if (!val) return
          this.listMessage = [];
          this.fetchProduct();
        }
      },
      listProduct() {
        this.$nextTick(this.checkOverflow)
      }
    },
  };
</script>

<style lang="css" scoped>
  .text-ellipsis-p {
    flex: 0 0 auto;
    max-width: 100px;
    padding: 3px;
    border: 1px solid #CDE5FF;
    border-radius: 5px;
  }
  .product-name {
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 12px;
  }
  .fullwidth-p {
    width: 90%;
  }
  .product-scroll {
    display: flex;
    overflow-x: auto;
    gap: 8px;
    padding-bottom: 4px;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .product-scroll::-webkit-scrollbar {
    display: none;
  }
  .scroll-btn {
    border: none;
    background: white;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    cursor: pointer;
    z-index: 2;
    margin-top: -5px;
  }

  .scroll-btn.left {
    margin-right: 6px;
  }

  .scroll-btn.right {
    margin-left: 6px;
  }
  .product-wrapper {
    position: relative;
    display: flex;
    align-items: center;
  }

</style>
